import { da, de, enGB as en, fi, nb, nl, ru, sv, fr } from 'date-fns/locale';

import { useGetCurrentLanguage } from '@legacy/apis/userSettingsAPI';

const localeMap = {
  da,
  de,
  en,
  fi,
  nb,
  nl,
  ru,
  sv,
  fr,
};

export const useGetDateLocale = () => {
  const { currentLanguage, isSuccess } = useGetCurrentLanguage();

  if (isSuccess) {
    return currentLanguage ? localeMap[currentLanguage] : en;
  }

  return en;
};
